import React from "react";
import { TABS } from "../utils/tabs";

const TAB_CONFIG = [
  { key: TABS.UPCOMING, label: "Upcoming" },
  { key: TABS.NEEDS_ATTENTION, label: "Needs Attention" },
  { key: TABS.ALL, label: "All" },
];

const JobsTabs = ({ activeTab, counts = {}, onChange }) => (
  <div className="jobs-tabs" role="tablist">
    {TAB_CONFIG.map(({ key, label }) => (
      <button
        key={key}
        type="button"
        role="tab"
        aria-selected={activeTab === key}
        className={`jobs-tab ${activeTab === key ? "active" : ""}`}
        onClick={() => onChange(key)}
      >
        <span className="jobs-tab-label">{label}</span>
        <span className="jobs-tab-count">{counts[key] ?? 0}</span>
      </button>
    ))}
  </div>
);

export default JobsTabs;
